import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const apps = [
  { to: '/sexlife-tracker', label: 'My SexLife Tracker', desc: 'Relationship wellness journal' },
  { to: '/growiq', label: 'GrowIQ', desc: 'Interactive learning quizzes' },
  { to: '/feel-o-meter-ai-mood-tracker', label: 'Feel-O-Meter', desc: 'AI mood tracker' },
  { to: '/rewardly-ai-card-rewards', label: 'Rewardly AI', desc: 'Card rewards maximizer' },
  { to: '/price-tracker-deal-alerts', label: 'Price Tracker', desc: 'Deal alerts & price history' },
];

const Header = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [appsOpen, setAppsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close mobile menu on route change
  useEffect(() => {
    setMenuOpen(false);
    setAppsOpen(false);
  }, [location.pathname]);

  // Close dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setAppsOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <header className="header">
      <div className="header-inner">
        <Link to="/" className="header-logo">
          <img src="/images/appshow-logo.png" alt="Appshow" className="header-logo-img" />
        </Link>

        {/* Desktop nav */}
        <nav className="header-nav" aria-label="Main navigation">
          <Link to="/" className={`nav-link${location.pathname === '/' ? ' active' : ''}`}>
            Home
          </Link>

          <div className="nav-dropdown" ref={dropdownRef}>
            <button
              className={`nav-link dropdown-trigger${apps.some(a => a.to === location.pathname) ? ' active' : ''}`}
              onClick={() => setAppsOpen(o => !o)}
              aria-expanded={appsOpen}
            >
              Products
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </button>
            {appsOpen && (
              <div className="dropdown-menu">
                {apps.map(app => (
                  <Link
                    key={app.to}
                    to={app.to}
                    className={`dropdown-item${location.pathname === app.to ? ' active' : ''}`}
                    onClick={() => setAppsOpen(false)}
                  >
                    <span className="dropdown-item-label">{app.label}</span>
                    <span className="dropdown-item-desc">{app.desc}</span>
                  </Link>
                ))}
              </div>
            )}
          </div>

          <Link to="/privacy" className={`nav-link${location.pathname === '/privacy' ? ' active' : ''}`}>
            Privacy
          </Link>
        </nav>

        {/* Hamburger */}
        <button
          className={`hamburger${menuOpen ? ' open' : ''}`}
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="mobile-menu">
          <Link to="/" className="mobile-link" onClick={() => setMenuOpen(false)}>Home</Link>
          <div className="mobile-section-label">Products</div>
          {apps.map(app => (
            <Link
              key={app.to}
              to={app.to}
              className="mobile-link"
              onClick={() => setMenuOpen(false)}
            >
              {app.label}
            </Link>
          ))}
          <Link to="/privacy" className="mobile-link" onClick={() => setMenuOpen(false)}>Privacy Policy</Link>
          <Link to="/terms" className="mobile-link" onClick={() => setMenuOpen(false)}>Terms</Link>
        </div>
      )}
    </header>
  );
};

export default Header;
